<div [formGroup]="form">
  <div [ngSwitch]="question.controlType" [class.gb-invalid]="!isValid">
    <mat-form-field class="form-field" *ngSwitchCase="controlType.Text">
      <mat-label [attr.for]="question.key">{{ question.label }}</mat-label>

      <!-- address can use google auto complete -->
      <input
        *ngIf="question.type === 'address' && shouldUseMapAutocomplete(); else defaultField"
        [formControlName]="question.key"
        [id]="question.key"
        [type]="question.type"
        matInput
        mapAutocomplete
        placeholder="{{ question.label }}"
        (change)="this.googlePlacesValidAddress = false"
        (placeResult)="addressPlaceResultCallback($event)"
      />
      <ng-template #defaultField>
        <input
          *ngIf="question.type !== 'address'"
          [formControlName]="question.key"
          [id]="question.key"
          [type]="question.type"
          matInput
        />
      </ng-template>
      <mat-icon *ngIf="question.icon" matSuffix>{{ question.icon }}</mat-icon>
      <mat-hint align="end">
        <span
          translate="UNKNOWN_ADDRESS"
          *ngIf="
            googlePlacesValidAddress === false &&
            form.get(question.key)?.value &&
            form.get(question.key)?.value.length > 0
          "
        ></span>
        <span
          translate="VALID_ADDRESS"
          *ngIf="googlePlacesValidAddress && form.get(question.key)?.value && form.get(question.key)?.value.length > 0"
        ></span>
      </mat-hint>
    </mat-form-field>

    <div *ngSwitchCase="controlType.MultipleChoice">
      <mat-label [attr.for]="question.key" [class.invalid]="showRequiredMessage">{{ question.label }}</mat-label>
      <mat-radio-group [formControlName]="question.key" [class.radio-group-invalid]="showRequiredMessage">
        <mat-radio-button *ngFor="let choice of question.choices" [value]="choice">
          {{ choice }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <mat-checkbox
      *ngSwitchCase="controlType.Checkbox"
      [formControlName]="question.key"
      [class.checkbox-invalid]="showRequiredMessage"
    >
      {{ question.label }}
    </mat-checkbox>

    <mat-error *ngIf="showRequiredMessage" translate="ACCOUNT.FIELD_REQUIRED" class="form-error"> </mat-error>

    <mat-hint *ngIf="question.helpText">{{ question.helpText }}</mat-hint>
  </div>
</div>
